import { Dot, StaveNote, Stem } from 'vexflow';
import type { VexNoteSpec } from './vexFlowMapper';
import { VEX_PRINT } from './vexPrintTheme';

function applyOpenHeadStyle(note: StaveNote, stroke: string) {
  // Bravura dibuja blancas/redondas como glifo SMuFL: relleno negro = cabeza hueca visible.
  note.setStyle({ fillStyle: stroke, strokeStyle: stroke, lineWidth: VEX_PRINT.openHeadStroke });
  for (let i = 0; i < note.getKeys().length; i += 1) {
    try {
      note.setKeyStyle(i, { fillStyle: stroke, strokeStyle: stroke, lineWidth: VEX_PRINT.openHeadStroke });
    } catch {
      /* índice fuera de rango */
    }
  }
}

export function createNoteFromSpec(spec: VexNoteSpec, color: string, printMode = false): StaveNote {
  const isOpenHead =
    !spec.isRest &&
    !spec.isBlank &&
    (spec.duration === 'w' || spec.duration === 'wr' || spec.duration === 'h' || spec.duration === 'hr');
  const stroke = printMode ? VEX_PRINT.noteColor : color;

  const note = new StaveNote({
    keys: spec.keys,
    duration: spec.duration,
    autoStem: !spec.isRest && spec.duration !== 'w' && spec.duration !== 'wr' && !spec.isBlank,
  });

  if (spec.dotted) note.addModifier(new Dot(), 0);

  if (!spec.isRest && spec.duration !== 'w' && spec.duration !== 'wr' && !spec.isBlank) {
    note.setStemDirection(Stem.UP);
  }

  if (spec.isBlank) {
    note.setStyle({ fillStyle: 'transparent', strokeStyle: 'transparent' });
  } else if (spec.isRest) {
    note.setStyle({ fillStyle: stroke, strokeStyle: stroke, lineWidth: VEX_PRINT.stemWidth });
  } else if (isOpenHead) {
    applyOpenHeadStyle(note, stroke);
  } else {
    note.setStyle({ fillStyle: stroke, strokeStyle: stroke, lineWidth: VEX_PRINT.stemWidth });
    for (let i = 0; i < note.getKeys().length; i += 1) {
      try {
        note.setKeyStyle(i, { fillStyle: stroke, strokeStyle: stroke, lineWidth: VEX_PRINT.stemWidth });
      } catch {
        /* índice fuera de rango */
      }
    }
  }

  return note;
}

export function styleNoteDots(
  note: StaveNote,
  color: string,
  ctx?: ReturnType<import('vexflow').Renderer['getContext']>,
) {
  const stroke = color;
  try {
    for (const dot of note.getModifiersByType(Dot)) {
      dot.setStyle({ fillStyle: stroke, strokeStyle: stroke, lineWidth: VEX_PRINT.stemWidth });
      if (ctx) {
        dot.setContext(ctx);
        dot.draw();
      }
    }
  } catch {
    /* sin puntillo */
  }
}
